import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface CallFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  leadStatus: string;
  onLeadStatusChange: (value: string) => void;
  priority: string;
  onPriorityChange: (value: string) => void;
  leadQuality: string;
  onLeadQualityChange: (value: string) => void;
  callType: string;
  onCallTypeChange: (value: string) => void;
}

export function CallFilters({
  searchTerm,
  onSearchChange,
  leadStatus,
  onLeadStatusChange,
  priority,
  onPriorityChange,
  leadQuality,
  onLeadQualityChange,
  callType,
  onCallTypeChange
}: CallFiltersProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
      <div className="space-y-2">
        <Label htmlFor="search" className="text-sm">Search</Label>
        <Input
          id="search"
          placeholder="Phone, name, email..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-11 text-base"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="lead-status" className="text-sm">Lead Status</Label>
        <Select value={leadStatus} onValueChange={onLeadStatusChange}>
          <SelectTrigger id="lead-status" className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Statuses</SelectItem>
            <SelectItem value="new">New</SelectItem>
            <SelectItem value="contacted">Contacted</SelectItem>
            <SelectItem value="qualified">Qualified</SelectItem>
            <SelectItem value="unqualified">Unqualified</SelectItem>
            <SelectItem value="converted">Converted</SelectItem>
            <SelectItem value="no_answer">No Answer</SelectItem>
            <SelectItem value="callback_scheduled">Callback Scheduled</SelectItem>
            <SelectItem value="lost">Lost</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="priority" className="text-sm">Priority</Label>
        <Select value={priority} onValueChange={onPriorityChange}>
          <SelectTrigger id="priority" className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Priorities</SelectItem>
            <SelectItem value="urgent">Urgent</SelectItem>
            <SelectItem value="high">High</SelectItem>
            <SelectItem value="medium">Medium</SelectItem>
            <SelectItem value="low">Low</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="lead-quality" className="text-sm">Lead Quality</Label>
        <Select value={leadQuality} onValueChange={onLeadQualityChange}>
          <SelectTrigger id="lead-quality" className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Qualities</SelectItem>
            <SelectItem value="hot">Hot</SelectItem>
            <SelectItem value="warm">Warm</SelectItem>
            <SelectItem value="cold">Cold</SelectItem>
            <SelectItem value="unqualified">Unqualified</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="call-type" className="text-sm">Call Type</Label>
        <Select value={callType} onValueChange={onCallTypeChange}>
          <SelectTrigger id="call-type" className="h-11">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Types</SelectItem>
            <SelectItem value="inquiry">Inquiry</SelectItem>
            <SelectItem value="quote_request">Quote Request</SelectItem>
            <SelectItem value="emergency">Emergency</SelectItem>
            <SelectItem value="follow_up">Follow-up</SelectItem>
            <SelectItem value="complaint">Complaint</SelectItem>
            <SelectItem value="other">Other</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}